/**
 * Home page datasets per platform. The Home page renders one layout and reads
 * its rows from here, so choosing which platform's content to show is a data
 * concern rather than a branch inside the page.
 */

import type { BrandId } from './brandThemes'
import {
  featuredMerch,
  troveArticles,
  spotlightAuthors,
  readerReviews,
  upcomingEvents,
  featuredBookBoxes,
} from './homePageData'
import {
  aftertideFeaturedMerch,
  aftertideTroveArticles,
  aftertideSpotlightAuthors,
  aftertideReaderReviews,
  aftertideUpcomingEvents,
  aftertideFeaturedBookBoxes,
} from './aftertideHomePageData'
import {
  defaultDiscoveryRows,
  aftertideDiscoveryRows,
} from './discoveryRowsData'

const homeData = {
  litlaunch: {
    featuredMerch,
    troveArticles,
    spotlightAuthors,
    readerReviews,
    upcomingEvents,
    featuredBookBoxes,
    discoveryRows: defaultDiscoveryRows,
  },
  aftertide: {
    featuredMerch: aftertideFeaturedMerch,
    troveArticles: aftertideTroveArticles,
    spotlightAuthors: aftertideSpotlightAuthors,
    readerReviews: aftertideReaderReviews,
    upcomingEvents: aftertideUpcomingEvents,
    featuredBookBoxes: aftertideFeaturedBookBoxes,
    discoveryRows: aftertideDiscoveryRows,
  },
}

export const brandHomeData: Record<BrandId, (typeof homeData)['litlaunch']> =
  homeData
